import { IToken, TokenUser } from '@shared';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { CurrentUserState } from '../store/currentUser/currentUser.reducer';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { IUser } from '@interfaces';
//import { User } from '../models/auth.models';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  currentUser$: Observable<any>;
  private tokenKey = environment.tokenKey;
  private profileKey = environment.profileKey;
  constructor(
    private _store: Store<{ currentUser: CurrentUserState }>,
    private cookieService: CookieService,
  ) {
    this.currentUser$ = this._store.select((state) => state.currentUser.currentUser);
  }

  setToken(token: string, key: string, rememberMe: boolean = false, userCredentials?: IUser) {
    this.cookieService.set(key, token.replace(/"/g, ''), { path: '/', secure: true });
    if (rememberMe && userCredentials) {
      this.cookieService.set('userEmail', userCredentials.email, { path: '/', secure: true });
      return;
    }
    this.cookieService.delete('userEmail', '/');
  }

  getTokens(): IToken {
    return {
      accessToken: this.cookieService.get('accessToken'),
      refreshToken: this.cookieService.get('refreshToken'),
      businessportalAccessToken: this.cookieService.get('businessportalAccessToken'),
      businessportalRefreshToken: this.cookieService.get('businessportalRefreshToken'),
    };
  }

  getCurrentUser() {
    return this.currentUser$;
  }
}
